import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

/**
 * Reference result body for Race to 2nd (bootstrap-vue result modal, type "race2"):
 * cards dealt round-robin to Player A..D ("1" skipped, slot still advances); each player with
 * cards gets a .casino-result-cards row, the winner (t1.win 1..4) a trailing winner.png;
 * rdesc[0] as Winner on the right.
 */
export default function Race2ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const players = [[], [], [], []];
  cards.forEach((c, idx) => {
    if (c && c !== "1") players[idx % 4].push(c);
  });
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5 card32result">
      <div className="col-12 col-lg-8">
        <div className="row row5">
          {players.map((p, i) =>
            p.length ? (
              <React.Fragment key={i}>
                {i > 0 && " "}
                <div className="col-12 col-lg-12">
                  <div className="casino-result-cards">
                    <h4 className="text-center d-inline-block">{`Player ${"ABCD"[i]}`}</h4>{" "}
                    {p.map((c, ci) => (
                      <div key={ci} className="casino-result-cards-item">
                        <img src={getCardImage(c)} />
                      </div>
                    ))}{" "}
                    {win === String(i + 1) && (
                      <div className="casino-result-cards-item">
                        <img src={WINNER_IMG} className="winner-icon" />
                      </div>
                    )}
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment key={i}>{i > 0 && " "}</React.Fragment>
            )
          )}
        </div>
      </div>{" "}
      <div className="col-12 col-lg-4">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
